import { connect } from 'react-redux';
import { updateWebcomponentConfig, getMaterialViaLinkThunk } from '@/store/actions/cmme';
import ArticleNumberModal from './ArticleNumberModal.jsx';

const mapStateToProps = ({ cmmeReducer }) => ({
  webComponentConfing: cmmeReducer.config,
});

const mapDispatchToProps = dispatch => ({
  getMaterialViaLinkThunk: (productId) => dispatch(getMaterialViaLinkThunk(productId)),
  updateWebcomponentConfig: (payload) => dispatch(updateWebcomponentConfig(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArticleNumberModal);
